


import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRoadProps {
    children: React.ReactNode;
}

const ProtectedRoad: React.FC<ProtectedRoadProps> = ({ children }) => {
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

    useEffect(() => {
        const verifyToken = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/admin/verify`, {
                    method: 'GET',
                    credentials: 'include',
                });

                const data = await response.json();
                if (data.success && data.role === 'admin') {
                    setIsAuthorized(true);
                } else {
                    setIsAuthorized(false);
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du token :', error);
                setIsAuthorized(false);
            }
        };

        verifyToken();
    }, []);

    if (isAuthorized === null) {
        return <div>Chargement...</div>;
    }

    if (!isAuthorized) {
        return <Navigate to="*" replace />;
    }
    return <>{children}</>;
};

export default ProtectedRoad;

